


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'quasar'

@Component
export default class TimerDisplay extends Vue {
  pad = format.pad

  @Prop({ default: 0 })
  readonly days!: number

  @Prop({ default: 0 })
  readonly hours!: number

  @Prop({ default: 0 })
  readonly minutes!: number

  @Prop({ default: 0 })
  readonly seconds!: number
}
